module.exports = __webpack_public_path__ + "img/dot-icon-active.04053302.svg";